import merInfo from "./nn/informasjon";

export default {
    "side.tittel": "Personopplysningar",
    "side.tilbake": "Tilbake",
    "side.slett": "Slett",
    "side.slett.kontaktadresse": "Slett kontaktadresse",
    "side.bekreft": "Stadfest",
    "side.lagre": "Lagre",
    "side.avbryt": "Avbryt",
    "side.leggtil": "Legg til",
    "side.leggtil.kontaktinformasjon": "Legg til telefonnummer i Nav sitt register",
    "side.valgfritt": " (valfritt)",
    "side.organisasjonsnummer": "Organisasjonsnummer {orgnr}",
    "side.endre": "Endre",
    "side.endre.alle.opplysninger": "Endre opplysningar",
    "side.endre.kontaktinformasjon": "Endre kontaktinformasjon",
    "side.endre.adresser": "Endre adresser",
    "side.endre.kontonummer": "Endre kontonummer",
    "side.endretil": "Endre til",
    "side.opphor": "Opphøyr",
    "anker.lenkehit": "Lenke hit",
    "brodsmulesti.minside": "Mi side",
    "brodsmulesti.dinepersonopplysninger": "Personopplysningar",
    "brodsmulesti.arbeidsforhold": "Arbeidsforhold",
    "header.hello": "Hei!",
    "header.hello.name": "Hei {name}!",
    "header.description": "<a>Les om personvern i Arbeids- og velferdsetaten her</a>",
    "header.obs":
        "Her kan du sjå opplysningar som Nav har registrert om deg. Du har rett til innsyn i personopplysningar Nav har registrert om deg, men det er ikkje sikkert du vil finne alle personopplysningar her. Det kan vere på grunn av tekniske og juridiske avgrensingar.",
    "personalia.tittel": "Personalia",
    "personalia.beskrivelse":
        "Vi må vite kven du er og korleis vi kan kontakte deg. Dersom du skal ha tenester eller søker om økonomisk støtte, treng vi opplysningar for å kunne vurdere kva du har krav på. For å kunne utbetale pengar må vi ha kontonummeret ditt og ei adresse.",
    "personalia.first_name": "Førenamn",
    "personalia.first_and_middle_name": "Føre- og mellomnamn",
    "personalia.surname": "Etternamn",
    "personalia.fnr": "Fødselsnummer",
    "personalia.dnr": "D-nummer",
    "personalia.foreign_id": "Utanlandsk ID",
    "personalia.email": "E-post",
    "personalia.language": "Språk",
    "personalia.citizenship": "Statsborgarskap",
    "personalia.birthplace": "Fødestad",
    "personalia.spesreg": "Spesialregistrering",
    "personalia.civil_status": "Sivilstand",
    "personalia.security_measure": "Tryggleikstiltak",
    "personalia.gender": "Kjønn",
    "personalia.customized_comm": "Tilpassa kommunikasjon",
    "personalia.source.folkeregisteret": "Kjelde: Folkeregisteret",
    "personalia.source.nav": "Kjelde: Nav",
    "personalia.source.dkif": "Kjelde: Kontakt - og reservasjonsregisteret",
    "personalia.link.folkeregisteret": "Endre i Folkeregisteret",
    "personalia.link.folkeregisteret.adresse": "Endre adresse i Folkeregisteret",
    "personalia.link.brukerprofil.endre": "Endre i Din profil",
    "personalia.link.brukerprofil.leggtil": "Legg til i Din profil",
    "personalia.link.dkif.endre": "Vil du endre informasjonen i Kontakt- og Reservasjonsregisteret?  ",
    "personalia.link.dkif.leggtil": "Gå til Kontakt- og reservasjonsregisteret ",
    "personalia.kontonr.feilmelding": "Det skjedde ein feil ved henting av kontoinformasjon. Prøv igjen seinare.",
    "personalia.kontonr": "Kontonummer",
    "personalia.iban": "IBAN",
    "personalia.kontonrelleriban": "Kontonummer / IBAN",
    "personalia.kontonr.oveskrift": "Kontonummer vi utbetalar til",
    "personalia.kontonr.ingenData": "Vi har ikkje registrert kontonummer på deg. <br></br>Du kan registrere kontonummer ved å trykke på «Legg til»",
    "personalia.bank": "Bank",
    "personalia.valuta": "Valuta",
    "personalia.bickode": "BIC / SWIFT-kode",
    "personalia.bankkode": "Bankkode",
    "personalia.tlfnr": "Telefon",
    "personalia.tlfnr.oveskrift": "Telefonnummer registrert hos Nav",
    "personalia.tlfnr.ingenData": `Vil du heller legge inn eit telefonnummer i <b>Nav sitt register</b>?
  Det nye telefonnummeret du legg inn, vil berre lagrast hos oss.`,
    "personalia.tlfnr.telefon": "Telefon {x}",
    "personalia.tlfnr.slett.overskrift": "Slett telefonnummer",
    "personalia.tlfnr.slett.alert": "Er du sikker på at du vil fjerne dette nummeret?",
    "personalia.tlfnr.paagaaendeendring.feilmelding": "Vi jobbar med å registrere telefonnummeret du har lagt til. Det vil snart bli synleg!",
    "personalia.spraak": "Språk/målform",
    "personalia.dkif.overskrift": "Opplysningar frå Kontakt - og reservasjonsregisteret",
    "personalia.dkif.beskrivelse":
        "Kontakt- og reservasjonsregisteret er eit felles nasjonalt register. Nav må ha kontaktopplysningane dine i dette registeret for å kunne sende deg meldingar og dokument elektronisk.",
    "personalia.dkif.ingenData": "<b>Ingen opplysningar registrert</b>",
    "adresse.tittel": "Adresser",
    "adresse.beskrivelse": `Under ser du adressetypar i Folkeregisteret. Du kan ha fleire adressetypar samtidig. Du kan endre adresser i Folkeregisteret hos Skatteetaten.<br></br><br></br>
<b>Bustadsadresse</b> <br></br> 
Adressa der du offisielt er registrert som busett.<br></br><br></br>
<b>Opphaldsadresse</b><br></br> 
Ei adresse der du oppheld deg for tida.<br></br><br></br>
<b>Postadresse (kontaktadresse)</b><br></br> 
Ei adresse der du vert nådd per post.<br></br> <br></br> 
<b>Delt bustad</b><br></br> 
Eit barn som bur fast hos både mor og far, kan ha to bustadadresser. Den eine adressa er registrert under delt bustad.`,
    "adresse.oppholdsadresse": "Opphaldsadresse",
    "adresse.oppholdsadresse.militaer": "Militær",
    "adresse.oppholdsadresse.utenriks": "Utanriks",
    "adresse.oppholdsadresse.paasvalbard": "På Svalbard",
    "adresse.oppholdsadresse.pendler": "Pendlar",
    "adresse.deltbosted": "Delt bustad",
    "adresse.bostedsadresse": "Bustadsadresse",
    "adresse.bostedsadresse.apneTekst": "Vis detaljar",
    "adresse.bostedsadresse.lukkTekst": "Skjul detaljar",
    "adresse.kontaktadresse": "Postadresse (kontaktadresse)",
    "adresse.kontaktadresse.utenlandsk": "Postadresse (utanlandsk kontaktadresse)",
    "adresse.kontaktadresse.norsk": "Postadresse (norsk kontaktadresse)",
    "adresse.kontaktadresse.nav": "Kontaktadresse registrert av Nav",
    "adresse.kontaktadresse.leggtil.folkeregisteret": "Endre adresse i Folkeregisteret",
    "adresse.kontaktadresse.slette.folkeregisteret": "Slette kontaktadresse",
    "adresse.utenlandskadresse": "Kontaktadresse i utlandet",
    "adresse.postadresse": "Postadresse",
    "adresse.adressetillegg": "Adressetillegg",
    "adresse.gate": "Gate",
    "adresse.postnummer": "Postnummer",
    "adresse.poststed": "Poststad",
    "adresse.dato": "Flyttedato",
    "adresse.dato.gyldigtil": "Gyldig til og med",
    "adresse.kommune": "Kommune",
    "adresse.bolignummer": "Bustadsnummer",
    "adresse.land": "Land",
    "adresse.overskrift": "Adresser som er registrert i Folkeregisteret",
    "adresse.overskrift.ovrige": "Øvrige registrerte adresser",
    "adresse.ikke.registrert": "Du har ikkje registrert bustadsadresse i Folkeregisteret",
    "adresse.slett.alert": "Vil du fjerne kontaktadressa og bruke folkeregistrert <br></br> adresse til å få post frå Nav?",
    "adresse.hjelpetekster.adressetyper":
        "<p>Postadresse inneheld gatenamn, gatenummer og postnummer.</p><p>Postboksadresse viser til ein postboks på eit postkontor eller post i butikk.</p>",
    "adresse.hjelpetekster.gyldigtil":
        "<p>Du kan sjølv velje kor lenge adressa skal være gyldig, maksimalt 1 år. Etter 1 år må du endre eller forlenge adressa.</p>",
    "adresse.hjelpetekster.co":
        "<p>Bur du midlertidig på ein annan persons adresse og ønsker posten dit? Då må posten være merka med den andre personen sitt namn. Det er ekstra viktig viss namnet ditt ikkje står på postkassa.</p>",
    "adresse.hjelpetekster.bolignummer": "<p>Bustadsnummer er ein del av adressa viss du bur i leiligheit i et hus med fleire bustadar.</p>",
    "adresse.hjelpetekster.bygningetasjeleilighet":
        "<p>Fyllast ut dersom adressa inneheld informasjon om bygning. Dømer er leiligheitsnummer, oppgang, suite, namn på bygg og etasje.</p>",
    "adresse.hjelpetekster.regiondistriktomraade":
        "<p>Fyllast ut dersom adressa inneheld namn på region eller område. Dømer er distrikt, stat og landsby.</p>",
    "adresse.hjelpetekster.utenlandsk.adresse":
        "<p>Dersom det ikkje er mogleg å skilje ut region, bygning, postkode eller stadsnann frå adressa, kan du skrive inn heile adressa i feltet adresse, slik den er oppgitt. Informasjonen skal ikkje stå fleire stadar.</p>",
    "adresse.hjelpetekster.tilleggsnavn":
        "<p>Adressetilleggsnamn er eit tillegg i den offisielle adressa.</p><p>Dette kan for eksempel vere namn på gardsbruk, kjente institusjonar/bygningar, grender, bustadsfelt, hyttefelt eller liknande.</p>",
    "arbeidsforhold.tittel": "Arbeidsforhold",
    "arbeidsforhold.beskrivelse":
        "<p>Nav treng informasjon om arbeidsforholda dine for å kunne vurdere behovet ditt for oppfølging og tenester frå Nav, og til å rekne ut kor mykje du kan få utbetalt i for eksempel sjukepengar, dagpengar og foreldrepengar. Andre offentlege etatar har også tilgang til opplysningar frå Arbeidsgivar og arbeidstakarregisteret.</p><p>Det er Arbeids- og velferdsetaten som eig og forvaltar Arbeidsgivar og arbeidstakarregisteret (Aa-registeret).<br></br><lenkeAaRegisteret>Her finn du meir informasjon om Arbeidsgivar- og arbeidstakarregisteret</lenkeAaRegisteret>.</p>",
    "arbeidsforhold.kilde": "Kjelde: Arbeidsgivar- og arbeidstakarregisteret<br></br><span>Dataane er rapportert av arbeidsgivar</span>",
    "arbeidsforhold.disclaimer":
        "Oversikta viser alle arbeidsforhold rapportert etter 01.01.2015.<br></br>Dersom det er feil i eit arbeidsforhold, kan arbeidsgivaren endre gjennom a-meldinga.",
    "arbeidsforhold.submitted.by": "Dataane er rapportert av arbeidsgivar",
    "utbetalinger.tittel": "Kontonummer for utbetaling",
    "utbetalinger.hjelpetekster.kontonummer":
        "<p>Når du mottek ytingar frå Nav må du oppgi ein bankkonto som står i ditt namn. Adressa som Nav har registrert på deg må vere lik den du har oppgitt til den utanlandske banken. </p><p>For utbetaling til europeiske bankar MÅ du oppgi IBAN. IBAN startar alltid med registrering av to bokstavar utan mellomrom, deretter kjem mellom 15 og 31 tal, avhengig av krava i det enkelte land. Eksempel: DK12389325974125698</p><p>Oppgir du IBAN-nummer, må du oppgi BIC.</p><p>Kontonummer som ikkje er IBAN, kan ha BIC.</p>",
    "utbetalinger.hjelpetekster.bic":
        "<p>BIC/SWIFT er eit internasjonalt system som vert nytta til å identifisere bankar. Du får oppgitt BIC av banken din. BIC/SWIFT-koda inneheld 8 eller 11 bokstavar.</p><p>Har du ein europeisk bankkonto må du oppgi både BIC-kode og IBAN.</p><p>Dersom landet nyttar bankkode, skal du oppgi BIC for dei bankane som har BIC.</p>",
    "utbetalinger.hjelpetekster.valuta":
        "<p>Gebyra kan bli lågare dersom du vel utbetaling i valutaen til landet du har busett deg i. Sjekk med banken kva som lønner seg. Har du ein konto som er knytt opp mot ein bestemt valuta (valutakonto), oppgir du denne valutaen til Nav.</p><p>Finn du ikkje valutaen på lista, kan du velje ein hovudvaluta: Amerikanske dollar (USD) eller euro (EUR).</p>",
    "utbetalinger.hjelpetekster.bankkode":
        "<p>I dette feltet fyller du ut bankkode, fedwire number (FW) eller routing number.</p><p>Oppgir du ei bankkode, treng du ikkje oppgi IBAN-nummer. Du oppgir BIC for de bankane som har det.</p><p>Land som bruker bankkode, er blant anna USA, Australia, Canada, Russland, New Zealand og Sør-Afrika.</p>",
    "kontaktinfo.tittel": "Kontaktinformasjon",
    "dsop.tittel": "Utlevering av personopplysningar",
    "dsop.levertedata": "Leverte data",
    "dsop.kilde": "Kjelde: Digital Samhandling Offentleg og Privat",
    "dsop.uthentingstidspunkt": "Uthentingstidspunkt",
    "dsop.personnummer": "Personnummer",
    "dsop.mottaker": "Selskap",
    "dsop.tema": "Tema",
    "dsop.lastned": "Last ned leverte data",
    "dsop.ingendata": "Ingen personopplysningar har blitt utlevert.<br></br><br></br>" + merInfo.dsop.info,
    "inst.tittel": "Institusjonsopphald",
    "inst.institusjon": "Institusjon",
    "inst.detaljer": "Detaljar",
    "inst.disclaimer":
        "Her kan du sjå institusjonsopphald som starta i 2020 eller seinare. Opphald som er registrerte med ein tidlegare startdato, og som har varigheit etter 1. januar 2020, blir også viste. Du kan ha tidlegare registrerte opphald. Ønskjer du å sjå desse opphalda, kan du <lenkeTilInnsyn>be om innsyn</lenkeTilInnsyn>.<br></br><br></br>Helseinstitusjonar, alders- og sjukeheimar og fengsel <lenkeTilInstMelding>pliktar å melde til Nav</lenkeTilInstMelding> om personar som blir skrivne inn og ut av institusjonen. Oppdagar du feil, må du kontakte institusjonen.",
    "inst.periode": "Periode",
    "inst.institusjonsnavn": "Institusjonsnamn",
    "inst.institusjonstype": "Institusjonstype",
    "inst.kategori": "Kategori",
    "inst.registreringstidspunkt": "Registreringstidspunkt",
    "inst.ingendata": "Det er ingen institusjonsopphald å vise.",
    "inst.fiktivSluttdato.tittel": "Sluttdato",
    "inst.fiktivSluttdato": "Sluttdato for opphaldet er ikkje mottatt. Nav har avslutta opphaldet maskinelt.",
    "inst.kilde": "KJELDE: INSTITUSJONSOPPHALDSREGISTERET<br></br><span>Dataa er rapporterte frå institusjonen.</span>",
    "kontaktogreservasjonsregister-disclaimer":
        "Du mottek post og informasjon frå det offentlege elektronisk. Grunnen til det er at du ikkje har reservert deg mot elektronisk kommunikasjon.",
    "kontaktogreservasjonsregister-disclaimer-reservert":
        "Du mottek viktige brev frå det offentlege kun på papir. Dette er fordi du har reservert deg mot elektronisk kommunikasjon. Stat og kommune kan likevel sende deg annan informasjon på e-post, sms eller som brev digitalt.",
    "kontaktinformasjon-kilde":
        "Kvar hentar vi kontaktinformasjonen frå? Nav hentar kontaktopplysningane dine frå Kontakt- og reservasjonsregisteret. Dette er eit felles, nasjonalt register som vert nytta av det offentlege for å kunne sende meldingar og dokument. Du kan også registrere telefonnummer du vil kontaktast på i Nav sitt register.",
    "medl.tittel": "Medlemskap og unntak frå <br></br> medlemskap i folketrygda",
    "medl.ingendata": "Du har ingen registrerte periodar.",
    "medl.oversikt.ingress":
        "Dersom du bur og jobbar i Norge, er du vanlegvis medlem i folketrygda. Periodar med denne type medlemskap blir ikkje vist i oversikta. Oversikta er berre aktuell for deg som har",
    "medl.oversikt.1": "budd, jobba eller studert i utlandet, og du har søkt om medlemskap i folketrygda og fått bekrefta det.",
    "medl.oversikt.2": "jobba i Norge, men var med i trygdeordninga i eit anna land.",
    "medl.situasjoner.tittel": "Ulike situasjonar",
    "medl.situasjoner.1":
        "Flyttar du til utlandet for å bu eller jobbe, avhenger medlemskap i folketrygda blant anna av kva du gjer og varigheita på opphaldet.",
    "medl.situasjoner.2":
        "Norske studentar i utlandet vil vanlegvis vere pliktige medlem i folketrygda viss dei får støtte frå Lånekassen for å studere på heiltid ved eit utanlandsk universitet eller ein høgskule.",
    "medl.situasjoner.3":
        "Er du busett i eit anna land, men jobbar heilt eller delvis i Norge, kan du vere med i trygdeordninga i bustadslandet ditt og være unnteke frå medlemskap i folketrygda.",
    "medl.folketrygden.tittel": "Kva betyr medlemskap i folketrygda?",
    "medl.folketrygden.ingress":
        "Medlemskap i folketrygda betyr at du har rettar og plikter i folketrygda. <lenkeTilFolketrygden> Les om medlemskap i folketrygda</lenkeTilFolketrygden>. Kontakt Nav dersom du har spørsmål om periodar med eller utan medlemskap i folketrygda, telefon (+47) 21 07 37 00.",
    "medl.folketrygden.lanekassen": "Kontakt Statens lånekasse for utdanning dersom du har spørsmål om periodar med støtte frå Lånekassen.",
    "medl.perioder.tittel": "Oversikt over periodar",
    "medl.perioder.alert":
        "Oversikten viser periodar frå og med 2015. Dersom perioda i 2015 heng saman med ei periode frå tidlegare år, vil den også bli vist.",
    "medl.medlemskap.med.tittel": "Med medlemskap",
    "medl.medlemskap.med.ingress": "Oversikta viser periodar der du har søkt Nav om medlemskap i folketrygda og fått stadfesta det.",
    "medl.medlemskap.uten.tittel": "Utan medlemskap",
    "medl.medlemskap.uten.ingress":
        "Oversikta viser periodar der Nav har fått informasjon frå trygdemyndigheitene i eit land om at du var med i trygdeordninga i bustadslandet ditt mens du jobba i Norge.",
    "medl.medlemskap.lanekassen.tittel": "Med støtte frå Lånekassen for å studere i utlandet",
    "medl.medlemskap.lanekassen.ingress": "Oversikta viser periodar der Lånekassen har registrert deg som student ved ein utanlandsk lærestad.",
    "medl.periode": "Periode",
    "medl.trygdedekning": "Trygdedekning",
    "medl.trygdedekning.hjelpetekst": "Trygdedekning viser kva slags medlemskap du har i folketrygda.",
    "medl.lovvalgsland": "Land",
    "medl.lovvalgsland.hjelpetekst": "Land viser kva lands trygdeordning du var med i, i perioda du var unnateke frå medlemskap i folketrygda",
    "medl.hjemmel": "Heimel",
    "medl.hjemmel.hjelpetekst":
        "Heimel viser grunnlaget ditt for medlemskap i folketrygda (lov eller avtale). Er du unnateke frå medlemskap i folketrygda, viser den grunnlaget for unntak.",
    "medl.statsborgerland": "Statsborgarland",
    "medl.studieland": "Studieland",
    "dittnavkontor.tittel": "Ditt Nav-kontor",
    "dittnavkontor.beskrivelse":
        "Dersom du allereie får oppfølging ved eit Nav-kontor, skal du fortsette å bruke dette kontoret. Dersom du ikkje får oppfølging, kan du bruke kontoret under.",
    "dittnavkontor.ingress": "Kontoret ditt er ",
    "dittnavkontor.select.label": "Nav-kontor",
    "dittnavkontor.postadresse": "Postadresse",
    "dittnavkontor.postboks": "Postboks",
    "dittnavkontor.publikumsmottak": "Publikumsmottak",
    "dittnavkontor.publikumsmottakfor": "Publikumsmottak for",
    "dittnavkontor.apningstider": "Opningstider",
    "dittnavkontor.spesielleapningstider": "Spesielle opningstider",
    "dittnavkontor.kontaktinfo.overskrift": "Kontakt Nav",
    "dittnavkontor.kontaktinfo.lenke": "Gå til kontaktinformasjon",
    "dittnavkontor.kilde": "Folkeregisteret",
    "lenker.tittel": "Fleire opplysningar om deg",
    "lenker.beskrivelse": "Vi har også opplysningar om deg som du ikkje ser på denne sida. Gå til dei ulike tenestane under og sjå opplysningar.",
    "lenker.pensjon.tittel": "Pensjonsopptening",
    "lenker.pensjon.beskrivelse": "Sjå pensjonsoppteninga di og rekn ut alderspensjonen din",
    "lenker.pensjon.lenkeTekst": "Gå til Din pensjon",
    "lenker.sykefravaer.tittel": "Ditt sjukefråvær",
    "lenker.sykefravaer.beskrivelse": "Sjå sjukefråværet og sjukemeldingane dine",
    "lenker.sykefravaer.lenkeTekst": "Dine sakar",
    "lenker.dokumentarkiv.tittel": "Dokumentarkiv",
    "lenker.dokumentarkiv.beskrivelse": "Sjå oversikt over dokumenta dine",
    "lenker.utbetalinger.tittel": "Utbetalingar",
    "lenker.utbetalinger.beskrivelse": "Sjå utbetalingane dine frå Nav (utbetalingar frå kommunen vert ikkje vist)",
    "lenker.cv.tittel": "CV",
    "lenker.cv.beskrivelse": "Sjå CV-en og jobbprofilen din",
    "lenker.stillingssok.tittel": "Lagra stillingssøk",
    "lenker.stillingssok.beskrivelse": "Sjå dine lagra stillingssøk på arbeidsplassen.no",
    "lenker.dsop.tittel": "Utlevering av personopplysningar",
    "lenker.dsop.beskrivelse": "Sjå opplysningar Nav har gitt til forsikringsselskap viss du har gitt samtykke",
    "lenker.dsop.info": merInfo.dsop.info,
    "lenker.inst.tittel": "Institusjonsopphald",
    "lenker.inst.beskrivelse": "Sjå institusjonsopphalda dine",
    "lenker.medl.tittel": "Medlemskap og unntak frå medlemskap i folketrygda",
    "lenker.medl.beskrivelse": "Sjå periodar ved utanlandsopphald, og periodar for deg som har jobba i Norge, men bur i eit anna land",
    "lenker.fullmakt.tittel": "Fullmakter",
    "lenker.fullmakt.beskrivelse": "Sjå fullmaktene dine",
    "lenker.skjerming.tittel": "Skjerming mot innsyn",
    "lenker.skjerming.beskrivelse": "Gjeld tilsette i Nav og familiemedlem",
    "felter.type.label": "Type",
    "felter.type.velg": "Vel type",
    "felter.merom": "Mer om",
    "felter.prioritet.label": "Prioritet",
    "felter.prioritet.velg": "Vel prioritet",
    "felter.landkode.label": "Landkode",
    "felter.tlfnr.label": "Telefonnummer",
    "felter.adressetype": "Type adresse",
    "felter.adressetype.gateadresse": "Veg- og stadsadresse",
    "felter.adressetype.postboksadresse": "Postboksadresse",
    "felter.adressetype.stedsadresse": "Stadsadresse",
    "felter.adressevalg.norsk": "Norsk adresse",
    "felter.adressevalg.utenlandsk": "Utanlandsk adresse",
    "felter.tilleggslinje.label": "C/O (valfri)",
    "felter.postbokseier.label": "Postbokseier (valfri)",
    "felter.tilleggslinje.placeholder": " ",
    "felter.gatenavn.label": "Gatenamn",
    "felter.gatenummer.label": "Nummer",
    "felter.gatebokstav.label": "Bokstav",
    "felter.bolignummer.label": "Bolignummer",
    "felter.gyldigtom.label": "Gyldig til",
    "felter.postnummer.label": "Postnummer",
    "felter.tilleggsnavn.label": "Adressetilleggsnamn (valfri)",
    "felter.postboks.label": "Postboks",
    "felter.postboksnummer.label": "Postboksnummer",
    "felter.postboksanlegg.label": "Postboksanlegg (valfri)",
    "felter.stedsadresse.label": "Stadsadresse",
    "felter.adresse.label": "Adresse",
    "felter.bygningetasjeleilighet.label": "Bygning (valfri)",
    "felter.regiondistriktomraade.label": "Region (valfri)",
    "felter.postkode.label": "Postkode (valfri)",
    "felter.bysted.label": "By / Stadsnamn (valfri)",
    "felter.bankens.adresse.label": "Bankens adresse",
    "felter.land.label": "Land",
    "felter.kontonummer.label": "Kontonummer",
    "felter.kontonummer.grouplegend": "Velg norsk eller utenlandsk kontonummer",
    "felter.kontonummervalg.norsk": "Norsk kontonummer",
    "felter.kontonummervalg.utenlandsk": "Utanlandsk kontonummer",
    "felter.utenlandskkonto.info":
        "Ver nøye med utfylling av bankinformasjon for utanlandsk konto slik at betalinga kjem fram til rett stad. Nav er ikkje ansvarleg for at opplysningane er rette. Det kan vere gebyr. Les meir om krav til <a> utanlandsk kontonummer </a>.",
    "felter.kontonummer.kontonummer.label": "Kontonummer / IBAN",
    "felter.bic.label": "BIC / Swift-kode",
    "felter.bankensland.label": "Bankens land",
    "felter.valuta.label": "Valuta",
    "felter.bankkode.label": "Bankkode",
    "felter.banknavn.label": "Bankens namn",
    "felter.bankidentifier.bic": "BIC / Swift-kode",
    "felter.bankidentifier.bankkode": "Bankkode",
    "felter.bankidentifier.harikke.bic": "Har ikkje BIC / Swift-kode",
    "felter.bankidentifier.harikke.bic.advarsel": "Dersom du ikkje fyller ut BIC / Swift-kode kan utbetalinga bli forsinka eller avvist.",
    "felter.landetbrukerbankkode.advarsel":
        "For <span>{land}</span> kan du oppgi både BIC/Swift-kode og bankkode. Du kan oppgi begge, men det er tilstrekkeleg med ei av kodene.",
    "validation.only.letters": "Berre skriv bokstavar",
    "validation.only.digits": "Berre skriv tal",
    "validation.postboks.pakrevd": "Postboks er nødvendig",
    "validation.coadressenavn.pakrevd": "Fyll inn namn på mottakar, eller fjern valt type frå nedtrekksmenyen",
    "validation.only.digits.space": " Berre skriv tal og mellomrom",
    "validation.only.letters.and.digits": "Berre skriv bokstaver og tal",
    "validation.only.letters.space.and.digits": " Berre skriv bokstavar, mellomrom og tal",
    "validation.min.one.letter": "Skriv minst ein bokstav",
    "validation.without.space": "Mellomrom er ikkje tillate",
    "validation.gatenavn.pakrevd": "Gatenamn er nødvendig",
    "validation.gatenavn.valid": " Berre skriv bokstavar og punktum",
    "validation.husnummer.pakrevd": "Nødvendig",
    "validation.husnummer.positive": "Ugyldig",
    "validation.type.pakrevd": "Type er nødvendig",
    "validation.prioritet.pakrevd": "Prioritet er nødvendig",
    "validation.tlfnr.pakrevd": "Telefonnummer er nødvendig",
    "validation.tlfnr.siffer": "Telefonnummer må vere tal",
    "validation.tlfnr.norske": "Norske telefonnummer må ha 8 tal",
    "validation.tlfnr.makslengde": "Telefonnummeret kan maksimalt ha 16 tal",
    "validation.tlfnr.eksisterer": "Dette telefonnummeret er allereie registrert",
    "validation.retningsnr.pakrevd": "Landkode er nødvendig",
    "validation.postnummer.pakrevd": "Postnummer er nødvendig",
    "validation.postboksnummer.pakrevd": "Nødvendig",
    "validation.tomdato.pakrevd": "Gyldig dato er nødvendig",
    "validation.tomdato.ugyldig": "Ugyldig dato",
    "validation.tomdato.fremitid": "Vel ein dato fram i tid",
    "validation.tomdato.maksetarfrem": "Vel en dato maksimalt 1 år frem i tid",
    "validation.gateadresse.pakrevd": "Gateadresse er nødvendig",
    "validation.stedsadresse.pakrevd": "Stadsadresse er nødvendig",
    "validation.land.pakrevd": "Land er nødvendig",
    "validation.bankidentifier.pakrevd": "Du må velje eit alternativ",
    "validation.bankidentifier.valid": "Dersom du fyller ut IBAN-nummer, må du også fylle ut BIC / Swift-kode",
    "validation.kontonummer.pakrevd": "Kontonummer er nødvendig",
    "validation.kontonummer.elleve": "Norske kontonummer må ha 11 tal",
    "validation.kontonummer.mod11": "Skriv inn eit gyldig kontonummer",
    "validation.kontonummer.idnr": "Kontonummer kan ikkje være eit fødselsnummer eller d-nummer.",
    "validation.ikke.iban": "Amerikanske kontonummer kan ikkje være IBAN",
    "validation.iban.pakrevd": "IBAN er nødvendig",
    "validation.iban.gyldig": "Gyldig IBAN er nødvendig",
    "validation.iban.country": "Du må taste inn et IBAN-nummer frå det landet du har valt.",
    "validation.banknavn.pakrevd": "Bandnamn er nødvendig",
    "validation.banknavn.ugyldig": "Inneheld ugyldige teikn",
    "validation.bankkode.pakrevd": "Bankkode er nødvendig",
    "validation.bankkode.lengde": "Bankkoder frå {land} må ha {siffer} tal",
    "validation.bic.pakrevd": "BIC / Swift-kode er nødvendig",
    "validation.bic.gyldig": "Gyldig BIC / Swift-kode er nødvendig",
    "validation.bic.country": "Du må taste inn en gyldig BIC / Swift-kode frå det landet du har valt.",
    "validation.valuta.pakrevd": "Valuta er nødvendig",
    "validation.adresse.pakrevd": "Første adresselinje er nødvendig",
    "validation.adresselinje.pakrevd": "Nødvendig når feltet under er utfylt",
    "validation.adresselinje.ugyldig": "Inneheld ugyldige teikn",
    "validation.svarteliste.felles": "Kan ikkje innehalde ord som «ukjent», «ikkje kjent», «veit ikkje», «uoppgitt», «n.n.», «nomen nescio»",
    "validation.bolignummer.ugyldig": "Bustadsnummer består av ein bokstav (L, H, U eller K) og fire tal.",
    "validation.firstchar.notspace": "Første bokstav kan ikkje være mellomrom",
    "validation.multiple.spaces": "Kan ikkje ha fleire samanhengande mellomrom",
    "validation.only.space.signs.or.digits": "Kan ikkje bestå av berre space, spesialteikn og/eller sifre",
    "validation.only.space.or.signs": "Kan ikkje bestå av berre space og/eller spesialteikn",
    "validation.fix.errors": "For å gå videre må du rette opp følgande:",
    "alternativer.tittel": "Meir informasjon",
    "alternativer.feilopplysninger.tittel": merInfo.feilopplysninger.tittel,
    "alternativer.feilopplysninger.melding": merInfo.feilopplysninger.melding,
    "alternativer.savneropplysninger.tittel": merInfo.savneropplysninger.tittel,
    "alternativer.savneropplysninger.melding": merInfo.savneropplysninger.melding,
    "alternativer.utlevere.tittel": merInfo.utlevere.tittel,
    "alternativer.utlevere.melding": merInfo.utlevere.melding,
    "alternativer.klage.tittel": merInfo.klage.tittel,
    "alternativer.klage.melding": merInfo.klage.melding,
    "select.sok": "Søk ...",
    "select.loading": "Lastar inn ...",
    "select.no.hits": "Ingen treff funne for",
    "endreKontonummer.tittel": "Endre kontonummer for utbetaling",
    "endreKontonummer.info":
        "Du kan ikkje endre kontonummer for økonomisk sosialhjelp eller andre kommunale tenestar her. <lenkeNavno>Endre kontonummer for utbetalingar frå kommunen.</lenkeNavno>",
    "endreKontonummer.lenkeURL": "https://www.nav.no/kontonummer/nn#kommune",
    "endreKontonummer.authInfo": "Du vert beden om å logge inn på nytt for å bekrefte endringa.",
    "endreKontonummer.success": "<p>Du har endra kontonummeret ditt.</p><p>Nav vil sende deg eit varsel om endringa på SMS og/eller e-post.</p>",
    "endreKontonummer.error": "Det skjedde ein feil ved endring av kontonummer.",
    "utbetalinger.info":
        "Dersom du ikkje kjenner igjen kontonummeret, må du ringe <tlfTilKontaktsenter>55 55 33 33</tlfTilKontaktsenter> i åpningstida, eller <lenkeTilKontaktOss>kontakte oss</lenkeTilKontaktOss> i våre digitale kanalar.",
};
